import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Breadcrumb, Table, CardHeader, Form } from 'react-bootstrap';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom'; // Assuming React Router is used
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Badge } from 'primereact/badge';
import { Image } from 'primereact/image';
import { Sidebar } from 'primereact/sidebar';
import { InputNumber } from 'primereact/inputnumber';
import { Tooltip } from 'primereact/tooltip';
import Logo from '../../assets/images/logo.png';
import nouserImg from '../../assets/images/no_user.png';
const Expenses = () => {
    const { accessToken, userId } = useAuth();
    const [selectedMonth, setSelectedMonth] = useState(''); // '' means all months
    const [selectedYear, setSelectedYear] = useState(''); // '' means all years
    const [visibleRight, setVisibleRight] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false); // State to track submission
    const [mode, setMode] = useState('Add'); // 'add' or 'edit'
    const [editingExpenseId, setEditingExpenseId] = useState(null); // To track the expense being edited
    const [expenses, setExpenses] = useState([]);
    const [newExpense, setNewExpense] = useState({
        description: '',
        amount: 0,
        date: '',
        file: null,
        status: '1', // Default status
    });
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const fetchExpenses = async () => {
        try {
            const query = new URLSearchParams();
            if (selectedMonth) query.append('month', selectedMonth);
            if (selectedYear) query.append('year', selectedYear);

            const response = await axios.get(`${config.apiBASEURL}/expensesRoutes/fetchallexpenses?${query.toString()}`, {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            setExpenses(response.data); // Store fetched expenses in state
        } catch (error) {
            console.error("Error fetching expenses:", error);
        }
    };


    // Fetch expenses when month or year changes
    useEffect(() => {
        fetchExpenses();
    }, [selectedMonth, selectedYear, accessToken]);



    const handleAddExpense = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // Set loading state to true
        if (!newExpense.date) {

            return;
        }

        const formData = new FormData();
        formData.append('description', newExpense.description);
        formData.append('purchased_month', newExpense.date.getMonth() + 1);
        formData.append('purchased_year', newExpense.date.getFullYear());
        formData.append('amount', newExpense.amount);
        formData.append('file', newExpense.file);
        formData.append('uploaded_by', userId);

        try {
            if (mode === 'Add') {
                // Add new expense
                await axios.post(`${config.apiBASEURL}/expensesRoutes/add-expenses`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${accessToken}` }
                });
            } else if (mode === 'Edit') {
                // Edit existing expense
                await axios.put(`${config.apiBASEURL}/expensesRoutes/edit-expense/${editingExpenseId}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${accessToken}` }
                });
            }

            handleSidebarClose();
            fetchExpenses(); // Refresh expenses list
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsSubmitting(false); // Reset loading state
        }
    };


    const handleEditButtonClick = (expense) => {
        setNewExpense({
            description: expense.description,
            amount: expense.amount,
            date: new Date(expense.purchased_year, expense.purchased_month - 1, 1),
            file: null, // File cannot be preloaded
            status: expense.status,
        });
        setEditingExpenseId(expense.expense_id);
        setMode('Edit');
        setVisibleRight(true);
    };



    const handleDeleteExpense = async (id) => {
        try {
            const response = await axios.delete(`${config.apiBASEURL}/expensesRoutes/delete-expense/${id}`, {
                headers: { Authorization: `Bearer ${accessToken}` }
            });

            fetchExpenses();  // Refresh expenses after deleting
        } catch (error) {

        }
    };


    const handleSidebarClose = () => {
        setVisibleRight(false);
        setNewExpense({
            description: '',
            amount: 0,
            date: '',
            file: null,
            status: '1',
        });
        setMode('Add'); // Reset mode
    };


    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={4} className="mb-4 d-lg-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Expenses</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Col sm={8} className="mb-4 d-flex justify-content-end align-items-center">
                        <Button
                            label='Add Expense'
                            icon='pi pi-plus'
                            className='py-2'
                            severity='primary'
                            onClick={() => setVisibleRight(true)}
                        />
                    </Col>

                    <Card>
                        <Card.Header className='d-flex justify-content-end align-items-center'>
                            <div className='d-flex'>

                                <select
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                    className="form-select me-2"
                                    style={{width:'150px'}}
                                >
                                    <option value="">All Months</option>
                                    {monthNames.map((month, index) => (
                                        <option key={index} value={index + 1}>{month}</option>
                                    ))}
                                </select>
                                <select
                                    value={selectedYear}
                                    onChange={(e) => setSelectedYear(e.target.value)}
                                    className="form-select"
                                    style={{width:'150px'}}
                                >
                                    <option value="">All Years</option>
                                    {/* Generate year options dynamically */}
                                    {Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i).map((year) => (
                                        <option key={year} value={year}>{year}</option>
                                    ))}
                                </select>

                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive">
                                <Table hover size="sm">
                                    <thead>
                                        <tr className="table-light">
                                            <th style={{ width: '150px' }}>Creation Date</th>
                                            <th style={{ width: '150px' }}>Image</th>
                                            <th>Description</th>
                                            <th style={{ width: '150px' }}>Amount</th>
                                            <th style={{ width: '150px' }}>Month</th>
                                            <th style={{ width: '150px' }}>Year</th>
                                            <th style={{ width: '150px' }}>Uploded by</th>
                                            <th style={{ width: '100px' }} className="text-center">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {expenses.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No expenses found
                                                </td>
                                            </tr>
                                        ) : (
                                            expenses.map((expense) => (
                                                <tr key={expense.expense_id}>
                                                    <td>{new Date(expense.createdAt).toLocaleDateString('en-gb', { day: '2-digit', month: 'short', year: 'numeric' })}</td>
                                                    <td><Image src={expense.expense_file_url||Logo} zoomSrc={expense.expense_file_url} alt="Image" width="80" height="auto" preview /></td>


                                                    <td>{expense.description}</td>
                                                    <td>{expense.amount}</td>
                                                    <td>{monthNames[expense.purchased_month - 1]}</td>
                                                    <td>{expense.purchased_year}</td>
                                                    <td>
                                                        <Tooltip
                                                            target={`.user-image-${expense.expense_id}`}
                                                            content={`${expense.uploader.first_name} ${expense.uploader.last_name}`}
                                                        />
                                                        <img
                                                            src={expense.uploader.profileImage.image_url || nouserImg}
                                                            alt="User Profile"
                                                            className={`user-image-${expense.expense_id}`} // Unique class for each image
                                                            width="30"
                                                            height="30"
                                                            style={{ borderRadius: '50%' }}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <Button
                                                            title="Edit"
                                                            icon="pi pi-pencil"
                                                            severity="info"
                                                            outlined
                                                            className="border-0 p-0 me-2"
                                                            onClick={() => handleEditButtonClick(expense)}
                                                        />
                                                        <Button
                                                            title="Delete"
                                                            icon="pi pi-trash"
                                                            severity="danger"
                                                            outlined
                                                            className="border-0 p-0"
                                                            onClick={() => handleDeleteExpense(expense.expense_id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                        </Card.Body>
                    </Card>
                </Row>
            </Row>
            <Sidebar visible={visibleRight} position="right" onHide={handleSidebarClose}>
                <h5 className='mb-4'>{mode} Expenses</h5>
                <Form onSubmit={handleAddExpense}>
                    <div className='mb-3'>
                        <Form.Label>Upload Image</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(e) => setNewExpense({ ...newExpense, file: e.target.files[0] })}
                            disabled={isSubmitting} // Disable input while submitting
                        />
                    </div>
                    <div className='mb-3'>
                        <Form.Label>Your Text</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={5}
                            className='h-auto'
                            value={newExpense.description}
                            onChange={(e) => setNewExpense({ ...newExpense, description: e.target.value })}
                            disabled={isSubmitting} // Disable input while submitting
                        />
                    </div>
                    <div className='mb-3'>
                        <Form.Label>Amount</Form.Label>
                        <InputNumber
                            value={newExpense.amount}
                            onValueChange={(e) => setNewExpense({ ...newExpense, amount: e.value })}
                            min={0}
                            mode="decimal"
                            showButtonBar
                            currency="USD"
                            locale="en-US"
                            disabled={isSubmitting} // Disable input while submitting
                        />
                    </div>
                    <div className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <Calendar
                            value={newExpense.date}
                            onChange={(e) => setNewExpense({ ...newExpense, date: e.value })}
                            dateFormat="dd/mm/yy"
                            placeholder="Select Date"
                            showIcon
                            disabled={isSubmitting} // Disable input while submitting
                        />
                    </div>
                    <div className='d-flex justify-content-end'>
                        <Button
                            label={isSubmitting ? "Saving..." : "Save"}
                            type="submit"
                            className='me-2'
                            severity='success'
                            disabled={isSubmitting} // Disable button while submitting
                        />
                        <Button
                            label="Cancel"
                            severity='danger'
                            type="button"
                            onClick={handleSidebarClose}
                            disabled={isSubmitting} // Disable button while submitting
                        />
                    </div>
                </Form>
            </Sidebar>


        </>
    );
};

export default Expenses;